import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import useSEO from '@/hooks/useSEO';

export default function NotFoundPage() {
    useSEO({ title: 'Page Not Found', description: 'The page you were looking for could not be found on VVVSI Trust website.' });
    return (
        <section className="section-pad" data-testid="not-found-page">
            <div className="container-page text-center py-24">
                <div className="font-display font-semibold text-6xl sm:text-8xl text-[hsl(var(--primary))]">
                    404
                </div>
                <h1 className="font-display text-2xl sm:text-3xl font-semibold mt-3">
                    Page not found
                </h1>
                <p className="mt-2 text-muted-foreground">
                    The page you were looking for doesn&apos;t exist.
                </p>
                <Link to="/" className="mt-6 inline-block">
                    <Button>Back to Home</Button>
                </Link>
            </div>
        </section>
    );
}
